import SaporeForm from "../forms/SaporeForm";
import TextField from "../forms/fields/TextField";
import EmailField from "../forms/fields/EmailField";
import OptionField from "../forms/fields/OptionField";
import MultipleOptionField from "../forms/fields/MultipleOptionField";

export default class LeadForm extends SaporeForm {
    static newEmpty(feature) {
        return new LeadForm(feature);
    }

    constructor(feature) {
        const fields = {
            fantasyName: new TextField(1, 256, false, '', feature),
            hasFranchise: new OptionField(feature.yesNoAnswers(), false, feature, feature.noAnswer()),
            franchiseBrandName: new TextField(0, 256, true, '', feature),
            commerceType: new OptionField(feature.commerceTypes(), false, feature, ''),
            commerceTypeSpecification: new TextField(0, 256, true, '', feature),
            interestProducts: new MultipleOptionField(feature.interestProducts(), true, feature, []),
            phone: new TextField(0, 64, true, '', feature),
            email: new EmailField(true, '', feature),
            originChannel: new OptionField(feature.originChannels(), false, feature, ''),
            howTheyKnewUs: new OptionField(feature.referralSources(), false, feature, ''),
            referralObservation: new TextField(0, 512, true, '', feature),
            hasTaxpayerIdentificationNumber: new OptionField(feature.yesNoAnswers(), false, feature, feature.noAnswer()),
            taxpayerIdentificationNumber: new TextField(11, 11, true, '', feature),
            businessName: new TextField(1, 256, true, '', feature),
            hasPremises: new OptionField(feature.yesNoAnswers(), false, feature, feature.noAnswer()),
            commercialChannel: new OptionField(feature.commercialChannels(), false, feature, ''),
        };
        super(fields, null, feature);
    }
}
